// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__2m76O","title":"Select_title___lDwA","label":"Select_label__U9H8B"};